module.exports = __webpack_public_path__ + "static/media/cricket.17928728.svg";